export const BASE_HEIGHT = 60; // used for computing the height of events, hour distance, etc
